import React, { useEffect, useState } from "react";
import {
  checkWidgetAdminOrNot,
  URL as apiUrl,
} from "../../../../utils/Constants";
import { axiosPost } from "../../../../utils/AxiosApi";
import "./templateGallery.scss";
import TemplateCard from "./TemplateCard";
import Switch from "@material-ui/core/Switch";
import swal from "sweetalert";
import { Spinner } from "reactstrap";

const TemplateGallery = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [watermark, setWatermark] = useState(false);

  const filteredTemplates = templates
    ? templates.filter((template) => template.hasWatermark === watermark)
    : [];

  useEffect(() => {
    setLoading(true);
    axiosPost(
      apiUrl.getAllTemplates,
      {},
      (response) => {
        if (response.status === 200) {
          let templates = response.data.data;
          templates.forEach((t) => {
            // assuming t.content has the HTML string
            const blob = new Blob([t.templateFormat], { type: "text/html" });
            t.url = URL.createObjectURL(blob); // assign blob URL
          });
          setTemplates(templates);
          setLoading(false);
        }
      },
      (error) => {
        setLoading(false);
        swal(
          "Oops",
          error.response.data.message || "Failed to fetch templates",
        );
      },
    );
  }, []);

  return (
    <div
      className="tt-widgetContent-tab-holder"
      style={{ height: "79.5vh", scrollbarWidth: "none" }}
    >
      <div className="template-gallery-heading tt-group-header">
        <div>Template Gallery</div>
        <div className="watermark-input">
          <label htmlFor="watermark">Watermark</label>
          <Switch
            className="watermark-switch"
            name="watermark"
            checked={watermark}
            onClick={(e) => setWatermark((prev) => !prev)}
            inputProps={{ "aria-label": "controlled" }}
          />
        </div>
      </div>
      {loading ? (
        <div className="template-gallery-spinner">
          <div className="loader">
            <Spinner color="primary"></Spinner>
          </div>
          <div style={{ fontSize: "16px", marginTop: "15px" }}>
            Please wait !! Processing.....
          </div>
        </div>
      ) : (
        <div className={`${filteredTemplates.length > 0 && "a4-grid"}`}>
          {filteredTemplates.length > 0 ? (
            filteredTemplates.map((t) => {
              return (
                <TemplateCard key={t.id} url={t.url} name={t.name} />
                // <div
                //     className="tt-widgetContent-tab-holder allCalendarDisplay m-3"
                //     style={{ width: "210px", height:"297px" }}
                // >
                //     <div dangerouslySetInnerHTML={{ __html: t.template }} />
                // </div>
              );
            })
          ) : (
            <p style={{ textAlign: "center", marginTop: "24px" }}>
              No Template Found
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default TemplateGallery;
